import styled from "styled-components";
import { COLOR_RED, MOBILE_L_BP } from "@website-builder/utilities-index";

export const VideoModalWrapper = styled.div`
	.modalContainer {
		div {
			div {
				background-color: ${COLOR_RED} !important;
			}
		}
	}
	.modalBody {
		width: 600px;
		.videoContainer {
			height: 360px;
			width: 600px !important;
		}
	}
	.closeButtonWrapper {
		text-align: right;
		position: absolute;
		right: -50px !important;
		top: -20px !important;
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		.modalBody {
			max-width: 280px;
			.videoContainer {
				max-width: 280px !important;
			}
		}
		.closeButtonWrapper {
			right: 0px !important;
		}
	}
`;
